import React from 'react';
import { ModuleId, OptimizationResult } from '../types';
import { Loader2 } from 'lucide-react';
import CashFlowModule from './modules/CashFlowModule';
import CompetitiveModule from './modules/CompetitiveModule';
import DebtModule from './modules/DebtModule';
import DynamicPricingModule from './modules/DynamicPricingModule';
import ExpensesModule from './modules/ExpensesModule';
import InventoryModule from './modules/InventoryModule';
import PayablesModule from './modules/PayablesModule';
import ScenarioModule from './modules/ScenarioModule';
import TaxModule from './modules/TaxModule';
import Glossary from './Glossary';
import FAQ from './FAQ';

interface ModuleViewProps {
  moduleId: ModuleId | null;
  moduleData: OptimizationResult | null;
  loading: boolean;
  onOptimizationComplete: (data: any) => void;
  onLoadingStart: () => void;
}

const ModuleView: React.FC<ModuleViewProps> = ({
  moduleId,
  moduleData,
  loading,
  onOptimizationComplete,
  onLoadingStart,
}) => {
  if (!moduleId) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Welcome to ProFinTech
          </h2>
          <p className="text-gray-600">
            Select a module from the sidebar to get started
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Running optimization...</p>
        </div>
      </div>
    );
  }

  switch (moduleId) {
    case 'cashflow':
      return <CashFlowModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'competitive':
      return <CompetitiveModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'debt':
      return <DebtModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'dynamicPricing':
      return <DynamicPricingModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'expenses':
      return <ExpensesModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'inventory':
      return <InventoryModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'payables':
      return <PayablesModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'scenario':
      return <ScenarioModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'tax':
      return <TaxModule
        data={moduleData as any}
        onOptimizationComplete={onOptimizationComplete}
        onLoadingStart={onLoadingStart}
      />;
    case 'glossary':
      return <Glossary />;
    case 'faq':
      return <FAQ />;
    default:
      return <div>Module not found</div>;
  }
};

export default ModuleView;
